import React from "react";

// Lazy loading for Components
export const Login = React.lazy(() => {
  return import("App/Auth/body/Login");
});

export const Register = React.lazy(() => {
  return import("App/Auth/body/Register");
});

export const RegisterPromo = React.lazy(() => {
  return import("App/Auth/body/RegisterPromo");
});

export const RedirectPassword = React.lazy(() => {
  return import("App/Auth/body/RedirectPassword");
});

export const UpdatePassword = React.lazy(() => {
  return import("App/Auth/body/UpdatePassword");
});

export const SubUser = React.lazy(() => {
  return import("App/Auth/body/SubUser");
});

export const Dashboard = React.lazy(() => {
  return import("App/Dashboard");
});

export const Restore = React.lazy(() => {
  return import("App/Restore");
});

export const FileRestore = React.lazy(() => {
  return import("App/Restore/Tabs/body/File");
});

export const ImageRestore = React.lazy(() => {
  return import("App/Restore/Tabs/body/Image");
});

export const Users = React.lazy(() => {
  return import("App/Users");
});

export const Activities = React.lazy(() => {
  return import("App/Activities");
});

export const Account = React.lazy(() => {
  return import("App/Account");
});

export const ProfileDetails = React.lazy(() => {
  return import("App/Account/Details/body/ProfileDetails");
});

export const PlanOptions = React.lazy(() => {
  return import("App/Account/Details/body/PlanOptions");
});

export const UpdateCreditCard = React.lazy(() => {
  return import("App/Account/Details/body/UpdateCreditCard");
});

export const BillingInformation = React.lazy(() => {
  return import("App/Account/Details/body/BillingInformation");
});
// import ProfileDetails from "App/Account/Details/body/ProfileDetails";
// import PlanOptions from "App/Account/Details/body/PlanOptions";
// import UpdateCreditCard from "App/Account/Details/body/UpdateCreditCard";
// import BillingInformation from "App/Account/Details/body/BillingInformation";
// export const ZebraDatePicker = React.lazy(() => {
//   return import("App/common/ui/ZebraDatePicker");
// });

// export const pdfMake = React.lazy(() => {
//   return import("pdfmake/build/pdfmake");
// });

// export const pdfFonts = React.lazy(() => {
//   return import("pdfmake/build/vfs_fonts.js");
// });
